import { Box } from 'components/ui';
import { Link, useLocation } from 'react-router-dom';
import { Item } from 'utils/types';
import { useWindowSize } from 'hooks/useWindowSize';
import { GRID_BREAKPOINTS } from '../constants';
import styled from 'styled-components';

interface FuturaItemPreviewProps {
  item: Item;
}

interface FuturaImageWrapperProps {
  height: string;
}

const FuturaImageWrapper = styled.div<FuturaImageWrapperProps>`
  border: 3px solid black;
  box-shadow: 5px 5px 5px 0 black;
  height: ${props => props.height};

  &:hover {
    transform: scale(1.03);
    box-shadow: 5px 5px 10px 0 black;
  }
`;

const FuturaItemPreview = ({ item }: FuturaItemPreviewProps) => {
  const location = useLocation();
  const ws = useWindowSize();

  return (
    <Box key={item.token_id}>
      <Link
        to={{
          pathname: `/futura/details/${item.token_id}`,
          state: {
            from: location,
          },
        }}
      >
        <Box width={[280, 180, 200]} margin="0 auto">
          <FuturaImageWrapper height={ws.width <= GRID_BREAKPOINTS.sm ? 'auto' : '200px'}>
            {item.attributes.image_url && (
              <img width="100%" src={item.attributes.image_url} alt={item.attributes.title} />
            )}
          </FuturaImageWrapper>
          <Box mt={2} mb={4} mx="auto">
            {item.attributes.title}
          </Box>
        </Box>
      </Link>
    </Box>
  );
};

export default FuturaItemPreview;
